import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store'
import zhCN from 'view-design/dist/locale/zh-CN'
import enUS from 'view-design/dist/locale/en-US'
import zh from './zh.json'
import en from './en.json'
import { locale } from 'view-design';

Vue.use(VueI18n)
// Vue.locale = () => {}

const locales = {
	zh: Object.assign(zh, zhCN),
	en: Object.assign(en, enUS)
}
const i18n = new VueI18n({
	locale: _DEFAULT_LANGUAGE_,
	messages: locales,
})

export const setup = lang => {
	if (lang === undefined) {
		lang = localStorage.getItem('localeLanguage')
		if (locales[lang] === undefined) {
			lang = _DEFAULT_LANGUAGE_
		}
	}
	localStorage.setItem('localeLanguage', lang)

	Vue.config.lang = lang
	i18n.locale = lang
	if (lang == 'zh') {
		locale('zh-CN', zhCN)
	} else {
		locale('en-US', enUS)
	}
	store.state.lang = lang
	store.state.countdownStatus.txt = i18n.t('test')
}

setup()
export default i18n
